import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const subscribeToTrackingUpdates = unaryRpc({
  name: "subscribeToTrackingUpdates",
  input: z.object({
    smsMarketingConsent: z.object({
      consented: z.boolean(),
      phoneNumber: z.string(),
    }),
    smsTransactionalConsent: z.object({
      consented: z.boolean(),
      phoneNumber: z.string(),
    }),
    emailMarketingConsent: z.object({
      consented: z.boolean(),
      email: z.string().email().nullish(),
    }),
  }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
});
